// SPDX-License-Identifier: MPL-2.0

/*
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */

export const APP_NAME = __NIGHTFALL_APP_NAME__;
export const APP_TITLE = __NIGHTFALL_APP_TITLE__;
export const APP_VERSION = __NIGHTFALL_APP_VERSION__;
export const APP_BUILD_ID = __NIGHTFALL_APP_BUILD_ID__;
export const APP_BUILD_NAME = __NIGHTFALL_APP_BUILD_NAME__;
export const APP_LICENSE = __NIGHTFALL_APP_LICENSE__;
export const APP_COPYRIGHT = __NIGHTFALL_APP_COPYRIGHT__;
